import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { AddGamesPointsLayer } from '../components/GamesPoints/AddGamesPointsLayer'

export const AddGamesPoints = () => {
  return (
    <MasterLayout>
        <AddGamesPointsLayer />
    </MasterLayout>
  )
}
